// React Lib
import React from "react";
// Component Styles
import { useStyles } from "./DeletableChipStyles";
// @otg-one/ui_components/components
import { Typography } from "../index";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
import { Close } from "../../sap_icons";
export const DeletableChip = (props) => {
    const classes = useStyles(props);
    const { id, children, onDeleteClick, style } = props;
    return (React.createElement("div", { id: id, className: classes.chipContainer, style: style },
        React.createElement(Typography, { id: `${id}-chip-text`, fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, size: 12, color: Color.neutral[0], className: classes.chipLabel }, children),
        React.createElement(Close, { className: classes.chipCloseButton, onClick: onDeleteClick })));
};
DeletableChip.defaultProps = {
    children: "",
    onDeleteClick: () => { }
};
export default React.memo(DeletableChip);
